// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","buttons":"CommonForm__buttons--I7","button":"CommonForm__button--Nb"};